import React, { Component, PropTypes } from 'react';
import idx from 'idx';
import classnames from 'classnames';
import Entries from 'focus_groups/containers/entries';

const MAX_ENTRIES = 12;

class EntryPicker extends Component {
  constructor(props) {
    super(props);
    this.state = { tooMany: false };
    this.toggleEntry = this.toggleEntry.bind(this);
    this.onActionClick = this.onActionClick.bind(this);
  }

  onActionClick() {
    const { showEditEntries, setEntries, onNext } = this.props;

    setEntries();

    if (!showEditEntries) {
      onNext();
    }
  }

  toggleEntry(entry) {
    const { selected, toggleEntry } = this.props;
    const revisionId = idx(entry.revisions, _ => _[0].id);

    if (!selected.includes(revisionId) && selected.length === MAX_ENTRIES) {
      this.setState({ tooMany: true });
      return;
    }

    this.setState({ tooMany: false });
    toggleEntry(revisionId);
  }

  render() {
    const { toggle, selected, showEditEntries, onBack } = this.props;
    const tooManyError = classnames({ 'entry-count-error': this.state.tooMany });
    const countClass = classnames('entry-count', {
      'entry-count-error': this.state.tooMany
    });
    const buttonText = showEditEntries ? "Done": "Next";

    return (
      <div>
        <div className="row">
          <div className="columns medium-16 large-12">
            <h2>
              { showEditEntries? 'Edit entries' : `Select up to ${MAX_ENTRIES} designs` }
              <span className={countClass}>({selected.length} / {MAX_ENTRIES}) selected</span>
            </h2>
            { showEditEntries?
            <p className={tooManyError}>
              Deselecting an entry will remove it from the group, but all votes cast will be
              preserved.
            </p>:
            <p className={tooManyError}>
              Click on any entry to select or un-select it.
              You can select up to {MAX_ENTRIES} designs for each focus group.
            </p> }
          </div>
        </div>
        <Entries onItemClick={this.toggleEntry} />
        <div className="modal-actions">
          { !showEditEntries &&
          <button className="btn btn-text btn-back" onClick={onBack}>
            <i className="fa fa-angle-left"></i> Back
          </button> }
          <button
            onClick={this.onActionClick}
            type="submit"
            disabled={selected.length === 0}
            className="btn btn-primary"
          >
            {buttonText}
          </button>
          <button type="button" onClick={toggle} className="btn btn-text">Cancel</button>
        </div>
      </div>);
  }
}

EntryPicker.propTypes = {
  selected: PropTypes.arrayOf(PropTypes.number),
  toggle: PropTypes.func.isRequired,
  setEntries: PropTypes.func.isRequired,
  toggleEntry: PropTypes.func.isRequired,
  showEditEntries: PropTypes.bool,
  onBack: PropTypes.func,
  onNext: PropTypes.func,
};

export default EntryPicker;



// WEBPACK FOOTER //
// ./focus_groups/components/entry_picker.jsx